import mixin from './projects.maloney.amsterdam';

export default mixin;
